import chainsig from '@bumblehead/gaql/src/gaqlchainsig.js'

import {
  gnerrLog as errLog,
  gnerrNodeChainMustReturnGraph as errNodeChainMustReturnGraph,
  gnerrNodeNSPropMustResolvePrimitive as errNodeNSPropMustResolvePrimitive
} from './gnerr.js'

import {
  gngraphIs as graphIs
} from './gngraph.js'

import {
  gnutilNumBoolOrStrIs as utilNumBoolOrStrIs
} from './gnutil.js'

const gnrun = async (ss, cfg, gr, nd, nhy, nspec, retgraph) => {
  const gst = {
    queries: cfg.gaqlqueries,
    sess: ss,
    cfg,
    graph: gr,
    node: nd,
    nhy
  }

  const qst = {
    target: null
  }

  // const val = await cfg.gaqlrun(gst, qst, nspec.chain)
  if (!nspec.chain)
    throw new Error('invalid chain')


  const val = await cfg.gaqlrun(
    gst, qst, ["gn:CHAIN", 'chainId', nspec.chain]
  ).catch(e => {
    errLog(cfg, gr, nd, { nspec })

    throw e
  })

  if (retgraph && !graphIs(gst.graph)) {
    throw errNodeChainMustReturnGraph(gr, nd, nspec, gst.graph)
  }

  return retgraph ? gst.graph : val
}

const gnrunrest = async (ss, cfg, gr, nd, nhy, nspec, target) => {
  if (!nspec || !nspec.chain || nspec.chain.length < 2)
    return target

  const gst = {
    queries: cfg.gaqlqueries,
    sess: ss,
    cfg,
    graph: gr,
    node: nd,
    nhy
  }

  const qst = { rowMap: {} }

  return cfg.gaqlrun(gst, qst,
    ["gn:CHAIN", 'chainId', nspec.chain.slice(1)], [target]
  ).catch(e => {
    errLog(cfg, gr, nd, { nspec })

    throw e
  })
}

// not very efficient here but maybe can be improved later
const gnrun_retDataWHERE = async (
  ss, cfg, gr, nd, keys, basearr, keyresolve, keyresolvecasttype
) => {
  let keyarr = keys || [],
      resarr = []

  await Promise.all(basearr.map(async baseelem => {
    const value = await gnrun(ss, cfg, gr, nd,
      baseelem,
      keyresolve)

    // where 'return' may be dynamic object, this
    // condition may need to be updated or changed
    if (!utilNumBoolOrStrIs(value)) {
      throw errNodeNSPropMustResolvePrimitive(
        gr, nd, baseelem, chainsig(['gn:CHAIN', '', keyresolve.chain]))
    }

    const valuefin = keyresolvecasttype === 'number'
      && typeof keyarr[0] === 'string'
      ? String(value) : value

    if (~keyarr.indexOf(valuefin)) {
      resarr.push(baseelem)
    }
  }))

  return resarr
}

export {
  gnrun,
  gnrunrest,
  gnrun_retDataWHERE
}
